export const OrderChangeConfigQueryKey = 'orderChangeConfigs'

export const OrderChangeConfigFieldsQueryKey = 'orderChangeConfigFields'
export const ProductConfigsQueryKey = 'product-configs'
